export const connectNode = 'https://fitt-bd.org/impact_db_backend/'
export const baseURL = 'https://fitt-bd.org/'
